export const loadGalleryItems = (gallery) => {
    return new Promise(function (resolve, reject) {
        fetch('https://sipxx3vm3f.execute-api.eu-central-1.amazonaws.com/dev/gallery', {
            method: 'POST',
            body: `query {listGalleryV2(gallery: "${gallery}"){id,title,icon,priority,gallery}}`
        })
            .then(resp => {
            resp.text()
                .then(response => {
                resolve(response);
            });
        });
    });
};
export const loadItems = (id) => {
    return new Promise(function (resolve, reject) {
        fetch('https://sipxx3vm3f.execute-api.eu-central-1.amazonaws.com/dev/gallery', {
            method: 'POST',
            body: `query {viewGallery(id: "${id}"){content}}`
        })
            .then(resp => {
            resp.text()
                .then(response => {
                resolve(response);
            });
        });
    });
};
